import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ModalModule } from 'ngx-bootstrap/modal';

import { ReadingListModule } from '®shared/reading-list/models';
import { RedirectionModule } from '®shared/redirection';
import { TrapFocusModule } from '®shared/trap-focus';
import { UriModule } from '®shared/url-utils';

import { ArchiveListModalComponent } from './archive-list-modal.component';
import { ArchiveListEffects } from './archive-list.effects';
import { archiveListReducer } from './archive-list.reducer';
import {
  STATE_FEATURE_ARCHIVE_LIST,
  getInitialArchiveListState,
} from './archive-list.state';
import { DeleteListModalComponent } from './delete-list-modal.component';
import { DeleteListEffects } from './delete-list.effects';
import { deleteListReducer } from './delete-list.reducer';
import {
  STATE_FEATURE_DELETE_LIST,
  getInitialDeleteListState,
} from './delete-list.state';

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([ArchiveListEffects, DeleteListEffects]),
    ModalModule,
    ReactiveFormsModule,
    ReadingListModule,
    RedirectionModule,
    StoreModule.forFeature(STATE_FEATURE_ARCHIVE_LIST, archiveListReducer, {
      initialState: getInitialArchiveListState,
    }),
    StoreModule.forFeature(STATE_FEATURE_DELETE_LIST, deleteListReducer, {
      initialState: getInitialDeleteListState,
    }),
    TrapFocusModule,
    UriModule,
  ],
  declarations: [ArchiveListModalComponent, DeleteListModalComponent],
  exports: [ArchiveListModalComponent, DeleteListModalComponent],
})
export class EditModalsModule {}
